import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

export default {
  [IntegrationTypes.BLING]: 'bling',
  [IntegrationTypes.TOTVS_WINTHOR]: 'totvsWinthor',
};
